import { connect } from 'react-redux';
import * as actions from './actions';
import Users from './Users';

const mapStateToProps = (state, ownProps) => {
  return {
    isFetchingList: state.users.isFetchingList,
    users: state.users.users,
    errors: state.users.errors,
    success: state.users.success,
    hasServerError: state.users.hasServerError,
    domainId: state.loginLayout.user.fvdomain_id,
    msg: state.users.msg,
    max_account_number: state.users.domain.max_account_num,
    view: state.loginLayout.view,
    ...ownProps
  };
};

const mapDispatchToProps = dispatch => ({
  fetchUserList: (token,id) => dispatch(actions.fetchUserList(token,id)),
  addUser: (token, payload) => dispatch(actions.addUser(token, payload)),
  editUser: (token, payload, id) => dispatch(actions.editUser(token, payload, id)),
  deleteUser: (token, id, fvdomain_id) => dispatch(actions.deleteUser(token, id, fvdomain_id)),
  clearErrors: () => dispatch(actions.clearErrors())
});

const UsersContainer = connect(mapStateToProps, mapDispatchToProps)(
  Users,
);

export default UsersContainer;



// WEBPACK FOOTER //
// src/routes/Users/UsersContainer.js